var version = '6.6.3';

module.exports = version;
